var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHdSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.0063 16.1187C13.6646 15.777 13.6646 15.223 14.0063 14.8813C14.348 14.5396 14.902 14.5396 15.2437 14.8813L18.7437 18.3813C19.0854 18.723 19.0854 19.277 18.7437 19.6187C18.402 19.9604 17.848 19.9604 17.5063 19.6187L14.0063 16.1187Z",
    fill: "#A1A5B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11.125C5 14.5077 7.74226 17.25 11.125 17.25C14.5077 17.25 17.25 14.5077 17.25 11.125C17.25 7.74226 14.5077 5 11.125 5C7.74226 5 5 7.74226 5 11.125ZM15.5 11.1249C15.5 13.5412 13.5413 15.4999 11.125 15.4999C8.70876 15.4999 6.75 13.5412 6.75 11.1249C6.75 8.7087 8.70876 6.74994 11.125 6.74994C13.5413 6.74994 15.5 8.7087 15.5 11.1249Z",
    fill: "#A1A5B7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdSearch);
export default __webpack_public_path__ + "static/media/hd_search.a6d7bf775d450e533884c2d56ef4ae22.svg";
export { ForwardRef as ReactComponent };